import type { ContentType } from "../types/menu";

export const getSelectedContentByPath = (pathname: string): ContentType => {
	if (pathname.startsWith("/informations")) {
		return "お知らせ";
	}
	if (pathname.startsWith("/terms")) {
		return "利用規約";
	}
	if (pathname.startsWith("/admins")) {
		return "ユーザー管理";
	}
	// ホームページなど、特定のコンテンツに属さない場合
	return null;
};

/**
 * 日付文字列またはDateオブジェクトを 'YYYY.M.D' 形式にフォーマットする
 * @param date - 日付文字列またはDateオブジェクト
 * @returns 'YYYY.M.D' 形式の文字列
 */
export const formatDate = (date: string | Date): string => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = d.getMonth() + 1;
	const day = d.getDate();
	return `${year}.${month}.${day}`;
};

/**
 * DateオブジェクトをAPIで送信する形式 'YYYY-MM-DD HH:mm:ss' に変換する
 * @param date - Dateオブジェクト
 * @returns 'YYYY-MM-DD HH:mm:ss' 形式の文字列
 */
export const formatDateTimeForApi = (date: Date): string => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * DateTimePickerのvalue（datetime-local形式）を 'YYYY-MM-DD HH:mm:ss' 形式に変換
 * @param datetimeLocal - 'YYYY-MM-DDTHH:mm' 形式の文字列
 * @returns 'YYYY-MM-DD HH:mm:ss' 形式の文字列
 */
export const convertDateTimeLocalToApi = (datetimeLocal: string): string => {
	const date = new Date(datetimeLocal);
	return formatDateTimeForApi(date);
};

/**
 * APIからの日時文字列をdatetime-local形式に変換
 * @param apiDateTime - 'YYYY-MM-DD HH:mm:ss' 形式の文字列
 * @returns 'YYYY-MM-DDTHH:mm' 形式の文字列
 */
export const convertApiDateTimeToLocal = (apiDateTime: string): string => {
	const date = new Date(apiDateTime);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	return `${year}-${month}-${day}T${hours}:${minutes}`;
};
